import _ from "lodash";
import React from "react";
import { Radio, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import { strpLocalize } from "../../../localization/localize";

function TableHeader(props) {
  const { classes, columns } = props;
  const labels = columns[0].labels;
  
  return (
    <thead>
      <tr className="text-center">
        <th />
        {
          labels.map((label, i) => (
            <th key={i}>
              <Typography variant="h3" className={classes.labels}>
                {strpLocalize(label)}
              </Typography>
            </th>
          ))
        }
      </tr>
    </thead>
  );
}

function TableBody(props) {
  const { classes, columns } = props;
  const cols = columns[0].values;

  return(
    <tbody>
      {
        // filter out when name is null b/c those are not to be rendered
        // this is to avoid updating questions.options
        // which will mess with the recorded indices when not all opts are displayed
        _.filter(props.rows, row => row.name != null).map(
          dimension => (
            <tr key={dimension.index}>
              <td style={{ textAlign: 'center' }} >{ strpLocalize(dimension.name) }</td>
              {
                cols.map(
                  (label, colIdx) => (
                    <td key={colIdx} className="text-center">
                      <Radio
                        className={clsx("likert-radio", classes.reduceRadioPadding)}
                        key={`likert-radio-${dimension.index}-${colIdx}`}
                        checked={ props.responses[dimension.index] === label }
                        value={dimension.index}
                        onChange={e => {
                          const newResponses = [...props.responses];
                          newResponses[dimension.index] = label;
                          props.updateResponses(newResponses);
                        }}
                        color="primary"
                        inputProps={{ "aria-label": "primary" }}
                      />
                    </td>
                  )
                )
              }
            </tr>
          )
        )
      }
    </tbody>
  )
}

const useStyles = (theme) => ({
  "reduceRadioPadding": {
    "@media (max-width: 960px)": {
      padding: "6px"
    }
  },
  "labels": {
    color: "rgba(0,0,0,0.87)"
  }
});

function Selector(props) {
  const hasContentToDisplay = !_.isEmpty(
    _.compact(
      _.filter(props.rows, (row) => row.name != null)
    )
  );
  
  return hasContentToDisplay ? (
    <table>
      <TableHeader {...props} />
      <TableBody {...props} />
    </table>
  ) : null;
}

export default withStyles(useStyles)(Selector);